import React from "react";
import { observer } from "mobx-react";

import { useTranslation } from "react-i18next";
import { BetDetailsModalStore } from "@state/stores/my-bets/BetDetailsModalStore";
import { CashoutStore } from "@state/stores/my-bets/CashoutStore";
import { BetSlipReceiptModalStore } from "@state/stores/my-bets/BetSlipReceiptModalStore";
import { SwiperWrapper } from "@components-shared/mobile/swiper/SwiperWrapper";
import { SwiperType } from "@components-shared/mobile/swiper/SwiperType";

export const BetDetailsModalTabs = observer(
	function BetDetailsModalTabs(props: {
		store: BetDetailsModalStore | BetSlipReceiptModalStore;
		activeTab: string;
		setActiveTab: React.Dispatch<React.SetStateAction<string>>;
	}) {
		const { store } = props;
		const { t } = useTranslation();

		let cashoutStore: CashoutStore;

		if (store instanceof BetDetailsModalStore) {
			cashoutStore = store.myBetsStore.cashoutStore;
		} else {
			cashoutStore = store.cashoutStore;
		}

		if (!store.currentBet) {
			return null;
		}

		const tabTitles = ["MARKETS", "BET_DETAILS"];

		if (store.currentBet.metadata) {
			tabTitles.push("FISCALIZATION");
		}

		if (store.currentBet.combinationBettingOffersCount > 1) {
			tabTitles.push("COMBINATIONS");
		}

		if (!store.currentBet?.isCashoutUnavailable) {
			tabTitles.push("CASHOUT_HISTORY");
		}

		if (!tabTitles.includes(props.activeTab)) {
			props.setActiveTab("MARKETS");
		}

		return (
			<div className="popup--details__tabs tabs--primary tabs--scroll popup__tabs">
				<SwiperWrapper type={SwiperType.SHOW_FIRST} customSpacing={0}>
					{tabTitles.map((tab, index) => {
						return (
							<SwiperWrapper.SliderItem
								key={tab}
								isActive={props.activeTab === tab}
								tabIndex={index}
							>
								<button
									key={tab}
									className={
										props.activeTab === tab
											? "tabs--primary__item tabs--primary__item--sml is-active"
											: "tabs--primary__item tabs--primary__item--sml"
									}
									onClick={() => {
										props.setActiveTab(tab);
										if (tab == "CASHOUT_HISTORY") {
											cashoutStore.fetchCashoutHistoryForBetSlip(
												store.currentBet
											);
										}
									}}
								>
									{t("BET_DETAILS_MODAL.TABS." + tab)}{" "}
									{tab === "COMBINATIONS" ? (
										<sup className="tabs--primary__item__sup">
											{store.currentBet &&
												store.currentBet
													.combinationBettingOffersCount}
										</sup>
									) : (
										""
									)}
								</button>
							</SwiperWrapper.SliderItem>
						);
					})}
				</SwiperWrapper>
			</div>
		);
	}
);
